export const PolicyTypes = {
  ByPattern: 'ByPattern',
  ByValue: 'ByValue',
} as const;

export type PolicyType = (typeof PolicyTypes)[keyof typeof PolicyTypes];

export interface BasePasswordPolicyDto {
  name: string;
  $type: PolicyType;
}

export interface ByPatternPolicyDto extends BasePasswordPolicyDto {
  $type: typeof PolicyTypes.ByPattern;
  pattern: string;
}

export interface ByValuePolicyDto extends BasePasswordPolicyDto {
  $type: typeof PolicyTypes.ByValue;
  value: number;
}

export type PasswordPolicyDto = ByPatternPolicyDto | ByValuePolicyDto;

export interface PasswordPoliciesDto {
  passwordPolicies: PasswordPolicyDto[];
}
